import { LandingPage as LandingPageForm } from '@bgea-js/form-templates';
import customConfirmationEsSHIC from "../../../../src/content/shic-od-spanish/customConfirmation";
import "../../../../src/content/shic-od-spanish/shic-od-es.scss";
import * as React from 'react';
export default {
  LandingPageForm,
  customConfirmationEsSHIC,
  React
};